import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export default function initSwiper() {
    // Ensure the DOM is fully loaded before initializing Swiper
    document.addEventListener('DOMContentLoaded', () => {
        bindDefaultSwiperInstances();
        bindEventsSwiperInstances();
    });
}

function bindEventsSwiperInstances() {
    const swiperElements = document.querySelectorAll('.events-swiper');
    swiperElements.forEach((swiperElement) => {
        new Swiper(swiperElement, {
            slidesPerView: 'auto',
            spaceBetween: 24,
            loop: true,
            breakpoints: {
                0: {
                    slidesPerView: 1.2,
                    spaceBetween: 16,
                },
                768: {
                    slidesPerView: 'auto',
                    spaceBetween: 24,
                },
            },
            pagination: {
                el: swiperElement.querySelector('.swiper-pagination'),
                clickable: true,
            },
            navigation: {
                nextEl: swiperElement.querySelector('.events-swiper__next'),
                prevEl: swiperElement.querySelector('.events-swiper__prev'),
            },
        });
    });
}

function bindDefaultSwiperInstances() {
    const swiperElements = document.querySelectorAll(".swiper");

    swiperElements.forEach((swiperElement) => {
        // Skip initialization for elements with no-slider class
        if (swiperElement.classList.contains('no-slider')) {
            return;
        }

        // Check if this is a mobile-only slider
        const isMobileSlider = swiperElement.classList.contains('mobile-slider');

        const swiperInstance = new Swiper(swiperElement, {
            slidesPerView: 3,
            spaceBetween: 20,
            watchOverflow: true,
            navigation: {
                nextEl: swiperElement.querySelector(".swiper-button-next"),
                prevEl: swiperElement.querySelector(".swiper-button-prev"),
            },
            scrollbar: {
                el: swiperElement.querySelector(".swiper-scrollbar"),
                hide: false,
                draggable: true,
            },
            mousewheel: {
                forceToAxis: true,
                sensitivity: 1,
                releaseOnEdges: true,
            },
            resistanceRatio: 0,
            on: {
                slideChange: function() {
                    const swiper = this;
                    const slidesPerView = swiper.params.slidesPerView;
                    const totalSlides = swiper.slides.length;
                    const currentIndex = swiper.activeIndex;

                    // Disable buttons at the edges
                    const nextButton = swiperElement.querySelector(".swiper-button-next");
                    const prevButton = swiperElement.querySelector(".swiper-button-prev");

                    if (nextButton) {
                        // Disable next button when at the last possible position
                        if (currentIndex >= totalSlides - slidesPerView) {
                            nextButton.classList.add('swiper-button-disabled');
                        } else {
                            nextButton.classList.remove('swiper-button-disabled');
                        }
                    }

                    if (prevButton) {
                        if (currentIndex === 0) {
                            prevButton.classList.add('swiper-button-disabled');
                        } else {
                            prevButton.classList.remove('swiper-button-disabled');
                        }
                    }
                },
                init: function() {
                    // Run the same logic on initialization
                    this.emit('slideChange');
                }
            },
            breakpoints: {
                300: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                    enabled: true,
                },
                781: {
                    slidesPerView: isMobileSlider ? 1 : 2,
                    spaceBetween: 30,
                    enabled: !isMobileSlider,
                },
                992: {
                    slidesPerView: isMobileSlider ? 3 : 3,
                    spaceBetween: 20,
                    enabled: !isMobileSlider,
                },
            },
        });
    });
}
